import { apiClient } from './client';
import type { ApiResponse } from '../types';

export interface Universe {
  universe_id: string;
  name: string;
  universe_type: string;
  join_code?: string | null;
  paused: boolean;
  created_at: string;
  settings?: { capacity?: number; pupilCount?: number; joinCode?: string; starMap?: { reservedSlots?: number } };
  _count?: { planets: number };
}

export interface RosterEntry {
  user: { user_id: string; name: string; email: string; active: boolean };
  planet: { planet_id: string; name: string; name_approved: boolean; stage: number; upgrade_count: number; created_at: string };
  balance: { current_balance: number; lifetime_earned: number; lifetime_spent: number };
}

export interface LeaderboardEntry {
  user_id: string;
  name: string;
  planet_name: string;
  stage: number;
  credits: number;
  score?: number;
  factionGoal?: string | null;
  scoreBreakdown?: Record<string, number>;
}

export const teacherApi = {
  getUniverses: () => apiClient.get<ApiResponse<Universe[]>>('/teacher/universes').then((r) => r.data),
  createUniverse: (name: string, capacity = 50) =>
    apiClient.post<ApiResponse<Universe>>('/teacher/universes', { name, capacity }).then((r) => r.data),
  getRoster: (universeId: string) =>
    apiClient.get<ApiResponse<RosterEntry[]>>(`/teacher/universes/${universeId}/roster`).then((r) => r.data),
  addStudent: (universeId: string, studentId: string) =>
    apiClient.post<ApiResponse<unknown>>(`/teacher/universes/${universeId}/students`, { studentId }).then((r) => r.data),
  removeStudent: (universeId: string, studentId: string) =>
    apiClient.delete(`/teacher/universes/${universeId}/students/${studentId}`).then((r) => r.data),
  getEvents: (universeId: string) =>
    apiClient.get<ApiResponse<unknown[]>>(`/teacher/universes/${universeId}/events`).then((r) => r.data),
  getTransactions: (universeId: string) =>
    apiClient.get<ApiResponse<unknown[]>>(`/teacher/universes/${universeId}/transactions`).then((r) => r.data),
  getTopics: (universeId: string) =>
    apiClient.get<ApiResponse<unknown[]>>(`/teacher/universes/${universeId}/topics`).then((r) => r.data),
  moderatePlanet: (planetId: string, approved: boolean) =>
    apiClient.post(`/teacher/planets/${planetId}/moderate`, { approved }).then((r) => r.data),
  pauseUniverse: (universeId: string, paused: boolean) =>
    apiClient.post(`/teacher/universes/${universeId}/pause`, { paused }).then((r) => r.data),
  resetPlanet: (planetId: string) =>
    apiClient.post(`/teacher/planets/${planetId}/reset`).then((r) => r.data),
  toggleLeaderboard: (universeId: string, enabled: boolean) =>
    apiClient.post(`/teacher/universes/${universeId}/leaderboard`, { enabled }).then((r) => r.data),
  getLeaderboard: (universeId: string) =>
    apiClient.get<ApiResponse<LeaderboardEntry[]>>(`/teacher/universes/${universeId}/leaderboard`).then((r) => r.data),
};
